import { Route, Routes } from 'react-router-dom';

import OfferDesignTable from './OfferDesignTable/OfferDesignTable';
import SelectOfferType from './SelectOfferType/SelectOfferType';

const OfferDesignView = () => {
  return (
    <Routes>
      <Route path="/" element={<OfferDesignTable />} />
      <Route path="/select-type" element={<SelectOfferType />} />
    </Routes>
  );
};

export default OfferDesignView;
